import {
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table"

import type { WebhooksTableColumnItem } from "./table-data"
type TableHeaderContentProps = {
  tableData: WebhooksTableColumnItem[]
}
export const TableHeaderContent = ({
  tableData,
}: TableHeaderContentProps) => {
  const visibleColumns = tableData.filter(
    (col) => col.visible
  )
  return (
    <TableHeader className="sticky top-0 z-20 h-10 w-full bg-background outline outline-1 outline-border">
      <TableRow>
        <TableHead className="lg:hidden">
          Detalhes
        </TableHead>
        {visibleColumns.map((col) => (
          <TableHead
            key={col.key}
            className={col.header.className}
          >
            {col.header.content}
          </TableHead>
        ))}
      </TableRow>
    </TableHeader>
  )
}
type EmptyDataMessageProps = {
  colSpan: number
}
export const EmptyDataMessage = ({
  colSpan,
}: EmptyDataMessageProps) => (
  <TableRow>
    <TableCell
      colSpan={colSpan}
      className="h-24 text-center"
    >
      Nenhum webhook encontrado.
    </TableCell>
  </TableRow>
)
type MobileContentProps = {
  item: WebhookConfigurationType
  tableData: WebhooksTableColumnItem[]
}
export const MobileContent = ({
  item,
  tableData,
}: MobileContentProps) => {
  const visibleColumns = tableData.filter(
    (col) => col.visible
  )
  return (
    <TableCell className="lg:hidden">
      <div className="grid grid-cols-2 gap-2">
        {visibleColumns.map((col) => {
          const mobileData = col.mobile(item)
          return (
            <div
              key={col.key}
              className={mobileData.className}
            >
              <span className="text-xs font-medium text-muted-foreground">
                {mobileData.label}
              </span>
              <div>{mobileData.content}</div>
            </div>
          )
        })}
      </div>
    </TableCell>
  )
}
type DesktopContentProps = {
  item: WebhookConfigurationType
  tableData: WebhooksTableColumnItem[]
}
export const DesktopContent = ({
  item,
  tableData,
}: DesktopContentProps) => {
  const visibleColumns = tableData.filter(
    (col) => col.visible
  )
  return (
    <>
      {visibleColumns.map((col) => {
        const cellData = col.cell(item)
        return (
          <TableCell
            key={col.key}
            className={cellData.className}
          >
            {cellData.content}
          </TableCell>
        )
      })}
    </>
  )
}
type TableContentProps = {
  data: WebhookConfigurationType[] | undefined
  tableData: WebhooksTableColumnItem[]
}
export const TableContent = ({
  data,
  tableData,
}: TableContentProps) => {
  const visibleColumns = tableData.filter(
    (col) => col.visible
  )
  if (!data || data.length === 0) {
    return (
      <EmptyDataMessage
        colSpan={visibleColumns.length + 2}
      />
    )
  }
  return (
    <>
      {data.map((item) => (
        <TableRow key={item.id} className="even:bg-zinc-50">
          <MobileContent
            item={item}
            tableData={tableData}
          />
          <DesktopContent
            item={item}
            tableData={tableData}
          />
        </TableRow>
      ))}
    </>
  )
}
